import URL from '../api_url';

export const REMOVE_BACKGROUND_API = `${URL}/remove-background`;